import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("chevron-left", [["path", {
	d: "m15 18-6-6 6-6",
	key: "1wnfg3"
}]]);
//#endregion
export { t };

//# sourceMappingURL=chevron-left-ObWP-3BV.js.map